import Immutable from 'immutable';
import { handleActions } from 'redux-actions';
import { TYPES as SEARCH_TYPES } from 'actions/searchActions';
import { checkForNestedProperty } from 'utils/utils';

const initialState = Immutable.List();

export default handleActions({
  [SEARCH_TYPES.SUGGEST_DESTINATIONS_SUCCESS]: (state, action) => {
    let response = state;

    if (checkForNestedProperty(action, 'response.result')) {
      response = Immutable.fromJS(action.response.result);
    }

    return response;
  },
  [SEARCH_TYPES.SUGGEST_HOTELS_SUCCESS]: (state, action) => {
    let response = state;

    if (checkForNestedProperty(action, 'response.result')) {
      response = Immutable.fromJS(action.response.result);
    }

    return response;
  },
  [SEARCH_TYPES.CLEAR_SUGGESTIONS]: () => initialState,
}, initialState);



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/searchReducer.js
 **/